module.exports = __webpack_public_path__ + "media/logos/logo_footer-0c86a194.png";